._6amz3i0 {
  border: none;
  max-height: inherit;
  max-width: inherit;
}
._6amz3i1 {
  max-height: 230px;
  overflow: auto;
  padding-top: var(--pluma-space-200);
}
._6amz3i2 {
  min-width: calc(var(--pluma-space-100) * 62);
}